module.exports = __webpack_public_path__ + "static/media/undoIcon.dbbad8c3.svg";